/**
 * Google Tag Manager (GTM) Utilities
 * 
 * GTM Container: GTM-M4TCFVRV
 * All tracking is managed through GTM interface at https://tagmanager.google.com
 */

// Push custom event to GTM dataLayer
export const pushToDataLayer = (data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    console.warn('GTM dataLayer not available');
  }
};

// E-commerce Events for GTM

// View item list (category page)
export const trackViewItemList = (items, listName) => {
  pushToDataLayer({
    event: 'view_item_list',
    ecommerce: {
      item_list_name: listName,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        price: item.price
      }))
    }
  });
};

// View item (product detail)
export const trackViewItem = (item) => {
  pushToDataLayer({
    event: 'view_item',
    ecommerce: {
      currency: 'USD',
      value: item.price,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        price: item.price,
        quantity: 1
      }]
    }
  });
};

// Add to cart
export const trackAddToCart = (item, quantity = 1) => {
  pushToDataLayer({
    event: 'add_to_cart',
    ecommerce: {
      currency: 'USD',
      value: item.price * quantity,
      items: [{
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        price: item.price,
        quantity: quantity
      }]
    }
  });
};

// Begin checkout
export const trackBeginCheckout = (items, totalValue) => {
  pushToDataLayer({
    event: 'begin_checkout',
    ecommerce: {
      currency: 'USD',
      value: totalValue,
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        price: item.price,
        quantity: item.quantity
      }))
    }
  });
};

// Purchase
export const trackPurchase = (transactionId, items, totalValue, tax = 0, shipping = 0) => {
  pushToDataLayer({
    event: 'purchase',
    ecommerce: {
      transaction_id: transactionId,
      value: totalValue,
      tax: tax,
      shipping: shipping,
      currency: 'USD',
      items: items.map(item => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        price: item.price,
        quantity: item.quantity
      }))
    }
  });
};

// Search
export const trackSearch = (searchTerm, results = 0) => {
  pushToDataLayer({
    event: 'search',
    search_term: searchTerm,
    results: results
  });
};

// Custom event
export const trackEvent = (eventName, eventData = {}) => {
  pushToDataLayer({
    event: eventName,
    ...eventData
  });
};

export default {
  pushToDataLayer,
  trackViewItemList,
  trackViewItem,
  trackAddToCart,
  trackBeginCheckout,
  trackPurchase,
  trackSearch,
  trackEvent
};
